import { FC } from 'react'
import { buttonVariants, Chip, cn, Stack } from 'design-system'

import { gqlDisplayName } from 'shared/lib/user'

import MessageButton from 'src/components/user/v2/message-button'
import FollowerInfo from 'src/components/user/v2/follower-info'
import { FollowButton } from '../follow-button'
import Avatar from '../avatar'
import { UserMenuType } from '../types'
import { Link } from 'src/lib/router'

interface MenuProps {
  user: UserMenuType
  isOwnProfile: boolean
  messagesEnabled: boolean
}

export const UsernameMenuContent: FC<MenuProps> = ({
  user,
  messagesEnabled,
  isOwnProfile
}) => {
  const { username, followees, followers } = user
  const profileDisplayName = gqlDisplayName(user)
  return (
    <Stack gap={2} className="w-64 p-4">
      <div className="flex max-w-full gap-x-2">
        <Avatar user={user} admin={false} className="shrink-0" />
        <div className="grow truncate">
          <p className="flex items-center justify-between gap-x-1 text-base font-medium">
            <span className="shrink truncate">{profileDisplayName}</span>
            {isOwnProfile ? (
              <Chip color="amber" size="sm" className="shrink-0 text-slate-700">
                Me
              </Chip>
            ) : null}
          </p>
          {username ? (
            <p className="truncate text-left text-xs text-slate-500">
              @{username}
            </p>
          ) : null}
        </div>
      </div>
      <FollowerInfo
        followingCount={followees.followeesCount || 0}
        followerCount={followers.followersCount || 0}
      />
      <div className="flex gap-x-2">
        <FollowButton
          userProfile={user}
          className="flex-1 justify-start"
          isOwnProfile={isOwnProfile}
        />
        {messagesEnabled ? (
          <MessageButton
            profile={user}
            className="flex-1"
            messagesEnabled={messagesEnabled}
            isOwnProfile={isOwnProfile}
          />
        ) : (
          <Link
            className={cn(buttonVariants({ buttonType: 'secondary' }))}
            href={`/user/${user.id}`}>
            View Profile
          </Link>
        )}
      </div>
    </Stack>
  )
}
